import { orderBy as _orderBy } from 'lodash-es';

import type { IEquipmentWithTranslation } from '../model/equipmentsList ';

interface IParams {
  searchValue: string;
  orderBy: string;
  direction: 'asc' | 'desc';
  templateId?: string;
  showIncludedTemplateValue?: boolean;
}

export const getFilteredEquipments = (arr: IEquipmentWithTranslation[], params: IParams) => {
  const { searchValue, orderBy, direction, templateId, showIncludedTemplateValue } = params;

  if (!showIncludedTemplateValue && !searchValue) return _orderBy(arr, orderBy, direction);

  const regExp = searchValue ? new RegExp(searchValue, 'i') : null;

  const filteredEquipments = arr.filter((equipment) => {
    const searchStringPoint = [
      equipment.originName,
      equipment.originLocationName,
      equipment.originAssetCode,
      equipment.name,
      equipment.location_name,
      equipment.asset_code,
      equipment.type?.name,
    ].join(' ');

    const matchesSearch = !regExp || regExp.test(searchStringPoint);

    const matchesTemplate =
      !showIncludedTemplateValue || (templateId && equipment.cost_saving_template?.id === +templateId);

    return matchesSearch && matchesTemplate;
  });

  return _orderBy(filteredEquipments, orderBy, direction);
};
